export default function () {
  return {
    countCells: 8,
    massive: [
      {
        dataField: 'region',
        cols: 1,
        rows: 1,
        text: '',
        class: 'd-flex flex-row align-center justify-start  ',
        headerClass: 'header-table-cell align-end border-bottom-zero',
        headerStyles: `min-width: 305px; `,
        order: 0,
        variable: true,
      },
      {
        dataField: 'secondCell',
        cols: 2,
        rows: 1,
        text: `Справочно:`,
        class: 'justify-start',
        headerClass: 'align-start border-bottom-zero table-header-info',
        headerStyles: `min-width: 160px`,
        order: 1,
        variable: false,
      },
      {
        dataField: 'pv',
        cols: 1,
        rows: 3,
        order: 2,
        variable: true,
        headerClass: 'align-start table-header-info',
        headerStyles: `min-width: 100px; color: rgba(0, 0, 0, 0.87)`,
        text: `Потребность в&nbsp;подготовке кадров на&nbsp;долгосрочный период`,
      },
      {
        dataField: '1',
        cols: 2,
        rows: 2,
        order: 5,
        variable: false,
        text: 'Общий объем КЦП на 2024/2025 год необходимый для подготовки специалистов в интересах данного региона вне зависимости от региона обучения',
        headerClass: 'border-bottom-zero',
        headerStyles: `justify-content: center; min-width: 300px; align-items: flex-start`,
      },
      {
        dataField: '1',
        cols: 2,
        rows: 2,
        order: 5,
        variable: false,
        text: 'Общий объем КЦП на 2024/2025 год',
        headerClass: 'border-bottom-zero',
        headerStyles: `justify-content: center; min-width: 300px; align-items: flex-start`,
      },

      ////////////////////////////////////////////////////// вторая строка хэдера

      {
        dataField: 'region1',
        cols: 1,
        rows: 1,
        text: '',
        class: 'd-flex flex-row align-center justify-start  ',
        headerClass: 'header-table-cell align-end table-header-info border-bottom-zero',
        headerStyles: `min-width: 305px; `,
        order: 0,
        variable: true,
      },
      {
        dataField: '2',
        cols: 2,
        rows: 1,
        order: 5,
        variable: false,
        headerClass: 'text-center border-bottom-zero',
        text: 'КЦП прошлых периодов\n',
        headerStyles: `justify-content: flex-start; min-width: 100px`,
      },
      {
        dataField: '33333',
        cols: 1,
        rows: 1,
        text: 'Регионы',
        class: 'd-flex flex-row align-center justify-start  ',
        headerClass: 'header-table-cell align-end table-header-info',
        headerStyles: `min-width: 305px; `,
        order: 0,
        variable: true,
      },
      {
        dataField: 'pvFirstSubject',
        cols: 1,
        rows: 1,
        order: 7,
        variable: true,
        class: 'pvFirstSubjectJc ',
        headerClass: 'table-header-info ',
        headerStyles: `justify-content: flex-start`,
        text: '2022',
      },
      {
        dataField: 'pvSecondSubject',
        cols: 1,
        rows: 1,
        order: 8,
        variable: true,
        class: 'pvSecondSubjectJc ',
        headerClass: 'table-header-info',
        text: '2023',
      },
      {
        dataField: 'kcp1',
        cols: 1,
        rows: 1,
        order: 12,
        variable: true,
        headerClass: ' header-table-cell  table-header-info',
        class: '',
        text: 'Прогноз',
        // text: '2024 год',
        headerStyles: `padding: 8px 15px 8px 0 !important;`,
      },
      {
        dataField: 'startValueStage3',
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        class: '',
        headerClass: ' header-table-cell table-header-info ',
        text: 'Субъект РФ',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
      },
      {
        dataField: 'kcp4',
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        class: '',
        headerClass: ' header-table-cell table-header-info ',
        text: 'Головной ЦО',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
      },
      {
        dataField: 'kcp44',
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell table-header-info',
        text: 'ЦО',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
      },
    ],

    rowsMassive: [ // строки таблицы
      {
        dataField: 'region',
        cols: 1,
        rows: 1,
        // text: 'Регионы',
        class: 'd-flex flex-row align-center justify-start  ',
        headerClass: 'header-table-cell align-end ',
        headerStyles: `min-width: 305px; justify-content: flex-start;`,
        order: 0,
        variable: true,
        template: r => `<div class="${r.regionId ? 'pl-7' : r.districtId ? `pl-3` : `font-weight-600`}">${r?.regionName}</div>`
      },
      {
        dataField: 'kcp22',
        cols: 1,
        rows: 1,
        order: 7,
        variable: true,
        class: ' ',
        headerClass: '',
        headerStyles: `justify-content: flex-start`,
        // text: '2022',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.kcp22, !r.regionId)
      },
      {
        dataField: 'kcp23',
        cols: 1,
        rows: 1,
        order: 8,
        variable: true,
        class: ' ',
        headerClass: ' ',
        // text: '2023 ',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.kcp23, !r.regionId)
      },
      {
        dataField: 'pv',
        cols: 1,
        rows: 1,
        order: 2,
        variable: true,
        styles: 'justify-content: unset;',
        // text: `Потребность в подготовке кадров на долгосрочный период`,
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.pv, !r.regionId)
      },
      {
        dataField: 'startValue',
        cols: 1,
        rows: 1,
        order: 12,
        variable: true,
        class: '',
        // text: '2024 год',
        styles: 'justify-content: unset;',
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.startValue, !r.regionId)
      },
      {
        dataField: 'startValueStage3', //Субъект РФ
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell ',
        class: '',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
        // template: (r) => this.$scripts.TableJs.formatValueInCell(r.stage2Value, !r.regionId)
        template: (r) => this.$scripts.TableJs.formatValueInCell(r.startValueStage3, !r.regionId)
      },
      {
        dataField: 'stage3Value', //Головной ЦО
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell ',
        class: '',
        headerStyles: `padding: 8px 15px 8px 0 !important`,
      },
      {
        dataField: 'value', //ЦО
        cols: 1,
        rows: 1,
        order: 14,
        variable: true,
        headerClass: ' header-table-cell',
        styles: 'justify-content: unset;',
        headerStyles: `padding: 8px 15px 8px 0 !important; `,
      },
    ]
  }
}